// extracted by css-extract-rspack-plugin
export default {"aiMarkdown":"xJSRw","tableWrapper":"FEW11","tableContainer":"LU383","smartLink":"yk1Fp","smartLinkInner":"jQ011","icon":"LoRM7"};